import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Modal } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { imageUrl, zeusApp } from '../../request/index';

// 定义人员数据类型
interface PersonnelData {
    id: number;
    name: string;
    position: string;
    address: string;
    image: string;
    detail: string;
}

// ========= 中文版本人员数据 =========
const mockDataZh: PersonnelData[] = [
    {
        id: 2,
        name: '丛钰',
        position: '创始合伙人 执行主任',
        address: '上海市',
        image: '9B21DF7941D7433EAB468F3FCF612FD3',
        detail:
            '丛钰律师毕业于北京大学，主要执业领域为企业破产清算、民商事争议解决、企业法律风险合规等。曾经处理过众多复杂的破产清算案件，在法律适用、资产处置、债权人权益保护等方面有着深厚的专业知识和丰富的实践经验。'
    },
    {
        id: 3,
        name: '邵俊',
        position: '创始合伙人 主任',
        address: '上海市',
        image: '8C7B975A7B7E4FF5B66BFB104EE41785',
        detail:
            '邵俊律师毕业于华东政法大学，有20余年法律行业从业经验，历任法院法官、党校校长。再国际制裁领域、涉外法律服务、RWA资产通证合规等领域有着丰富的实战经验。'
    },
    {
        id: 1,
        name: '马涛',
        position: '创始合伙人',
        address: '上海市',
        image: '2062D97D1EC5499C8A354A1D9F0D2FD3',
        detail:
            '马涛律师曾为多家大型企业担任法务总监，擅长搭建企业合规运营框架，聚焦劳动用工、合同交易、财税合规、知识产权等企业高频业务场景，防范经营风险。'
    }
];

// ========= 英文版本人员数据 =========
const mockDataEn: PersonnelData[] = [
    {
        id: 2,
        name: 'Cong Yu',
        position: 'Founding Partner · Executive Director',
        address: 'Shanghai, China',
        image: '9B21DF7941D7433EAB468F3FCF612FD3',
        detail:
            'Attorney Cong Yu graduated from Peking University. His practice focuses on corporate bankruptcy, civil and commercial dispute resolution, and corporate compliance. He has extensive experience in complex bankruptcy cases, asset disposal, and creditor rights protection.'
    },
    {
        id: 3,
        name: 'Shao Jun',
        position: 'Founding Partner · Director',
        address: 'Shanghai, China',
        image: '8C7B975A7B7E4FF5B66BFB104EE41785',
        detail:
            'Attorney Shao Jun graduated from East China University of Political Science and Law. With over 20 years of experience, he has served as a judge and dean of a Party School. He is highly experienced in international sanctions, cross-border legal services, and RWA asset tokenization compliance.'
    },
    {
        id: 1,
        name: 'Ma Tao',
        position: 'Founding Partner',
        address: 'Shanghai, China',
        image: '2062D97D1EC5499C8A354A1D9F0D2FD3',
        detail:
            'Attorney Ma Tao has served as legal director for several large enterprises. He specializes in building compliance systems and preventing corporate risk in labor, contracts, taxation, and intellectual property.'
    }
];

const ContactPart1: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);

    const [partList, setPartList] = useState<PersonnelData[]>([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [activeItem, setActiveItem] = useState<PersonnelData | null>(null);

    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    useEffect(() => {
        // 根据语言切换数据源
        setPartList(languageCode === 'en' ? mockDataEn : mockDataZh);
    }, [languageCode]);

    const openModal = (item: PersonnelData) => {
        setActiveItem(item);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setActiveItem(null);
    };

    return (
        <div className="about-part1">
            <div className='contactPart1-h1' style={{ color: '#000' }}>
                {languageCode === 'en' ? 'Personnel Overview' : '人员概括'}
            </div>

            <div className='personnel-container'>
                {partList.map((person) => (
                    <div
                        key={person.id}
                        className='personnel-card'
                        onClick={() => openModal(person)}
                    >
                        <div className='personnel-image'>
                            <img
                                src={`${imageUrl}${person.image}?zeus-app=${zeusApp}`}
                                alt=""
                            />
                        </div>

                        <div className='personnel-info'>
                            <div className='personnel-name'>{person.name}</div>
                            <div className='personnel-position'>{person.position}</div>
                            <div className='personnel-address'>{person.address}</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* 弹窗 */}
            <Modal
                open={modalOpen}
                centered
                width={1200}
                closable={false}
                footer={null}
            >
                <div className="plan-content">
                    <div className='plan-content-header'>
                        <div>{activeItem?.name}</div>
                        <CloseCircleOutlined
                            onClick={() => closeModal()}
                            style={{ fontSize: "35px", cursor: "pointer" }}
                        />
                    </div>

                    <div style={{ fontSize: "18px", color: '#000', fontWeight: '600' }}>
                        {activeItem?.position}
                    </div>

                    <div className='plan-line'></div>

                    <div className="plan-note-body">
                        {activeItem?.detail}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ContactPart1;
